import { toPixel } from "../utils";
export var configurableProps = [/* 静态属性 */
/* 动态属性 */

/* 扩展属性 */
'visible'];
export var allProps = configurableProps.concat(['position', 'offset']);
export var setterMap = {
  visible: function visible(val, instance) {
    if (instance) {
      if (val) {
        instance.show();
      } else {
        instance.hide();
      }
    }
  }
};
export var converterMap = {
  offset: toPixel
};